export default function PreliminaryDataBanner() {
  return (
    <div className="flex items-start gap-2.5 rounded-lg border border-warning-200 bg-warning-50 px-4 py-3">
      <i className="ri-alert-line text-warning-600 text-base shrink-0 mt-0.5" />
      <p className="text-xs text-warning-800 leading-relaxed">
        <span className="font-semibold">Estimativa visual preliminar — requer validação em campo.</span>{" "}
        Estes dados são gerados por análise assistida por IA (metodologia FITA v1.0) a partir de ortoimagens e servem
        para planejamento territorial e estatísticas iniciais. Nenhum valor deve ser tratado como dado oficial antes
        da validação técnica em campo.
      </p>
    </div>
  );
}
